module.exports = __webpack_public_path__ + "static/media/mail2.4cfd9b84.ico";